import { createSelector } from '@reduxjs/toolkit';

import { useReduxSelector } from '../../../external/hooks';

import { chatSelector } from './root';

export const chatUrlSelector = createSelector(chatSelector, state => state.activeChatUrl);

export function useChatUrlSelector(): string | undefined {
  return useReduxSelector(chatUrlSelector);
}
